import styled from '@emotion/styled';
import { Button } from 'ds/components/button';

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const SubmitButton = styled(Button)`
  border: ${({ theme }) => theme.colors.brand.main};
  background: ${({ theme }) => theme.colors.brand.main};

  &:hover {
    border: ${({ theme }) => theme.colors.brand.main};
    background: ${({ theme }) => theme.colors.brand.main};
  }
`;
